export enum cookiePrefix {
  GOOGLE_ANALYTICS_GA = '_ga', // Google Analytics to store and count pageviews and tagID like _ga_8428YW132D.
  GOOGLE_ANALYTICS_GID = '_gid', // Google Analytics to store and count pageviews.
  GOOGLE_ANALYTICS_GAT = '_gat', // Google Analytics to read and filter requests from bots.
}
